<template>
    <div>
        <b-button variant="primary" @click.prevent="toggleCreate">
            {{ !is_creating ? "Add a new itinerary item" : "Cancel" }}
        </b-button>

        <div class="create-itinerary-item__form-wrapper" v-if="is_creating">
            <b-form @submit.prevent="onSubmit">
                <b-form-group>
                    <label>
                        Title
                    </label>

                    <b-form-input
                        type="text"
                        v-model="form.title"
                        required>    
                    </b-form-input>

                    <label>
                        Time
                    </label>
                    
                    <date-picker 
                        :datestring="form.time" 
                        :config="datepicker.config"
                        @changed="(new_time) => {
                            form.time = new_time;
                        }">
                    </date-picker>
  
                    <label>
                        Body
                    </label>

                    <b-form-textarea
                        v-model="form.body"
                        required>    
                    </b-form-textarea>
                </b-form-group>

                <b-button type="submit" variant="primary">
                    Add
                </b-button>
            </b-form>
        </div>
    </div>
</template>

<script>
    import DatePicker from '@/components/DatePicker.vue';
    import { SERVER_TIME_FORMAT, LOCAL_TIME_FORMAT } from "@/constants.js";

    export default {
        components: {
            DatePicker
        },

        props: ['dayId'],

        data() {
            return {
                is_creating: false,
                
                form: {
                    day_id: this.dayId,
                    time: null,
                    title: "",
                    body: ""
                },

                datepicker: {
                    config: {
                        format: SERVER_TIME_FORMAT,
                        display_format: LOCAL_TIME_FORMAT
                    }
                }
            }
        },

        methods: {
            toggleCreate() {
                this.is_creating = !this.is_creating;
            },

            onSubmit() {
                this.$emit('created', { ...this.form });
                this.is_creating = false;
                this.clear();
            },

            clear() {
                this.form.title = "";
                this.form.body = "";
            }
        }
    }
</script>

<style scoped lang="scss">
    .form-group {
        margin: 0;
    }

    textarea {
        margin-bottom: 10px;
    }

    .create-itinerary-item__form-wrapper {
        padding: 10px;
        border: 1px solid lightgrey;
    }
</style>